import { useLazyQuery } from '@apollo/client/react';
import { useTheme } from '@emotion/react';
import { useAtomValue } from 'jotai';
import React, { useEffect } from 'react';

import { Box, Flex, Icon, Text } from '~/components/blocks';
import { QuestionnaireSheet } from '~/components/partials';
import { QuestionnaireSheetClipButton } from '~/components/partials/QuestionnaireSheetClipButton';
import { GetQuestionnaireSheetDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { draftAppointmentPatientFileAreaState } from '~/state/reception_drawer/atoms';

export const Questionnaire = () => {
  const { patientId } = useAtomValue(draftAppointmentPatientFileAreaState);
  const theme = useTheme();
  const [getQuestionnaires, { data, loading }] = useLazyQuery(GetQuestionnaireSheetDocument);

  const sheet = getNode(data, 'Patient')?.questionnaireSheet || undefined;
  const disabled = loading || !sheet?.answers;

  useEffect(() => {
    if (patientId) {
      getQuestionnaires({ variables: { patientId: patientId } });
    }
  }, [getQuestionnaires, patientId]);

  return (
    <Flex flexDirection="column">
      <Flex marginBottom={theme.space.l} justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <Icon size="m" icon="document" />
          <Text fontWeight="bold" marginLeft={theme.space.xs}>
            問診
          </Text>
        </Flex>
        <QuestionnaireSheetClipButton disabled={disabled} sheet={sheet} />
      </Flex>
      <Box position="relative" marginBottom={theme.space.xxl}>
        <QuestionnaireSheet loading={loading} sheet={sheet} />
      </Box>
    </Flex>
  );
};
